import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';
import { Center } from 'legacyComponents/styled/lib';

import {
  Wrapper,
  Head,
  Salary,
  HeadingStyled,
  ButtonStyled,
  Body,
} from './careers.styled';

@withNamespaces()
@observer
export class JD extends React.Component {
  render() {
    const { title, isExpanded, jobPath, salary, children } = this.props;

    const ApplyButton = props => (
      <a href={`${this.props.customLink} | ${title}`}>
        <ButtonStyled
          size={props.size || 'small'}
          text={<Trans>Apply for Position</Trans>}
        />
      </a>
    );

    return (
      <>
        <Wrapper>
          {isExpanded ? (
            <Head isExpanded={isExpanded}>
              <HeadingStyled size='medium' level={1}>
                <Trans>{title}</Trans>
                <Salary>{salary}</Salary>
              </HeadingStyled>
              <ApplyButton />
            </Head>
          ) : (
            <Link
              name='home.company.careers.position'
              params={{ position: jobPath }}
            >
              <Head isExpanded={isExpanded}>
                <HeadingStyled size='medium' level={3}>
                  <Trans>{title}</Trans>
                  <Salary>{salary}</Salary>
                </HeadingStyled>
                <ButtonStyled size='small' text={<Trans>Apply</Trans>} />
              </Head>
            </Link>
          )}
          <Body isVisible={isExpanded}>{children}</Body>
        </Wrapper>
        {isExpanded && (
          <Center>
            <ApplyButton size='default' />
          </Center>
        )}
      </>
    );
  }
}

JD.defaultProps = {
  customLink: 'mailto:talent@wikifactory.com?subject=Wikifactory',
};

JD.propTypes = {
  title: PropTypes.string,
  body: PropTypes.node || PropTypes.string,
  isExpanded: PropTypes.bool,
  salary: PropTypes.string,
  jobPath: PropTypes.string,
  children: PropTypes.array,
  customLink: PropTypes.string,
};
